var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',[_c('div',{staticClass:"error text-center pa-4"},[_c('h2',[_vm._v("Twoja sesja wygasła")]),_c('h3',[_vm._v("Zaloguj się ponownie")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }